import React from 'react';
import { reduxForm } from 'redux-form';

import { AppliedMenuListFormEnum as Fields } from 'Common/FieldEnum';
import { APPLIED_MENU_LIST_FORM_NAME } from 'Common/FormEnum';
import { RangeDatePickerField } from 'Common/SemanticWrapper';

class AppliedMenuListForm extends React.Component {
  render() {
    return (
      <div className="cm-date-range-container">
        <div className="cm-date-range-label">Select Date Range:</div>
        <RangeDatePickerField
          fromName={Fields.StartDate}
          toName={Fields.EndDate}
        />
      </div>
    );
  }
}

AppliedMenuListForm = reduxForm({
  form: APPLIED_MENU_LIST_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(AppliedMenuListForm);

export { AppliedMenuListForm };



// WEBPACK FOOTER //
// ./src/pages/managemenu/tabs/AppliedMenuListForm.js